export default __webpack_public_path__ + "static/media/Tecnologia_conectividad_tvs_ntorq_racing.86706a45.jpg";